<template>
  <div class="bot-main">
    <el-row class="bot-row">
      <el-col :xs="0" :sm="6" :md="6" :lg="8" :xl="8" style="text-align: center;">
        <router-link to="/">
          <img src="https://blhc806.oss-cn-hangzhou.aliyuncs.com/wmUsImg/sysImg/logo@2x.png" alt="" class="logo" />
        </router-link>
      </el-col>
      <el-col :xs="24" :sm="18" :md="18" :lg="16" :xl="16" class="bot-box">
        <div class="bot-text" v-for="(item, index) in navList" :key="index" @click="headerClick(item, index)">{{
          item.name }}</div>
      </el-col>
    </el-row>
    <div class="bot-Copyright">
      Copyright © 2024-2025 ALY HOME Copyright
    </div>
  </div>
</template>
<script>
export default {
  name: "BotFooter",
  components: {},
  data() {
    return {
      navList: [
        { name: 'ABOUT US', path: '/' },
        // { name: 'DRAPERY', path: '/goodsList', type: '0', value: "curtainList" },
        // { name: 'TRACERY', path: '/goodsList', type: 1, value: "traceryList" },
        // { name: 'ACCESSORY', path: '/goodsList', type: 2, value: "accessoryList" },
        { name: 'CONTACT US', path: '/contact' },
        { name: 'COOKIES', path: '/cookie' },
        { name: 'PRIVACY', path: '/privacy' },
        { name: 'TERMS OF USE', path: '/TermsOfUse' }
      ],
    };
  },
  created() { },
  mounted() { },
  beforeDestroy() { },
  methods: {
    headerClick(data, index, value = {}) {
      this.selIndex = index;
      sessionStorage.setItem('NAV_ACTIVE_INDEX', index);
      window.scrollTo({ top: 0,behavior: "instant"});
      let obj = {
        type: data.type || '',
        categoryId: value.categoryId || ''
      }
      this.$router.push({
        path: data.path,
        query: data.path == '/goodsList' ? obj : {}

      })
    },
  },
};
</script>
<style scoped>
.bot-main {
  width: 100%;
  box-sizing: border-box;
  background: #EDEBE9;
}

.bot-box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.bot-text {
  font-size: 16px;
  color: #3D3D3D;
  width: 18%;
  margin: 20px 0;
  cursor: pointer;
}

.logo {
  width: 68px;
  height: 68px;
}

.bot-row {
  height: 200px;
  display: flex;
  align-items: center;
  font-weight: bold;
}

.bot-Copyright {
  border-top: 1px solid #ccc;
  text-align: center;
  padding: 30px 0;
  color: #3D3D3D;
  font-weight: bold;
}
@media (max-width: 768px) {
  .bot-box{
    justify-content: space-around;
   
  }
  .bot-text{
  font-size: 2.5rem !important;
  }
  div{
    font-size: 3rem;
  }
}
</style>
